import { render, staticRenderFns } from "./MPopupWebPrivate.vue?vue&type=template&id=fd5ae34c&"
import script from "./MPopupWebPrivate.vue?vue&type=script&lang=ts&"
export * from "./MPopupWebPrivate.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports